module.exports = __webpack_public_path__ + "img/dummy_image.d3420b9c.svg";